<div class="diagnostic-dashboard">
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
  </div>
}

  @if (!loading) {
<div>
    <div class="gt-page-header">
      <span style="font-size: 16px; font-weight: bold;">{{titleName}}</span>
    </div>

    @if (dashboardCards.length > 0) {
<div class="filters-header">
      @for (card of dashboardCards; track $index) {
<span
            class="channel-tab"
            [class.active]="selectedChannel?.id === card.id"
            (click)="channelChange(card)"
            style="cursor: pointer; padding: 5px 10px; margin-right: 5px;">
        {{card.name || card.label}}
      </span>
}
    </div>
}

    @if (!gettingStatedPage) {
<div class="dashboard-content">
      <div class="card-container">
        @for (card of dashboardCardsList; track $index) {
<div class="dashboard-card" (click)="viewDetailsModal(card)">
          <div class="card-header">
            <span>{{card.name || card.label}}</span>
          </div>
          <div class="card-body">
            <p>{{card.description || ''}}</p>
          </div>
        </div>
}
      </div>
    </div>
}

    @if (gettingStatedPage) {
<div class="details-panel">
      <div class="details-header">
        <span style="font-weight: bold;">{{childDetailObj?.name || childDetailObj?.label}}</span>
        <i class="fa fa-times" style="cursor: pointer; float: right;" (click)="closeDetails()"></i>
      </div>
      <div class="details-body">
        <p>{{childDetailObj?.description || 'No details available.'}}</p>
      </div>
    </div>
}
  </div>
}
</div>
